import React, { FunctionComponent } from 'react';
import { Grid } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';
import { BlueTypography } from 'components/SharedStyledElements';

interface Props {
  title: string;
}

const { Container, Cell } = Grid;

const CellStyled = styled(Cell)`
  display: inline-flex;
`;

export const TypographyStyled = styled(BlueTypography)`
  margin: 0 25px 0 0;
`;

const AssetsVouchersSubpageHeader: FunctionComponent<Props> = ({ title, children }) => (
  <Container columns={3}>
    <CellStyled width={3}>
      <TypographyStyled variant="h1">{title}</TypographyStyled>
      <Cell middle>{children}</Cell>
    </CellStyled>
  </Container>
);

export default AssetsVouchersSubpageHeader;
